export default {
  switchAccount: "Смена Аккаунта",
  login: "Вход",
  loginFirst: "Пожалуйста, сначала войдите",
  start: "Начать",
  hasHistory: "Вы уже ответили на некоторые вопросы.",
  loadHistory: "Хотите продолжить?",
  cancel: "Нет",
  confirm: "Да",
  contact:
    "Оставив свои контактные данные, вы получите шанс выиграть бонусные награды!",
  completed: "Опрос пройден!",
  leaveMessage:
    "Оставив свои контактные данные, вы получите шанс выиграть бонусные награды!",
  enterEmail: "Адрес эл. почты:",
  enterPhone: "Номер телефона:",
  submit: "Отправить",
  leave: "Выйти",
  submitted: "Отправлено",
  thanks: "Спасибо!",
  opinion: "Ваше мнение?",
  prev: "Пред.",
  next: "След.",
  unlikely: "Крайне маловероятно",
  likely: "Весьма вероятно",
  claimYourRewards: "Вы можете забрать свои награды.",
  rewardSent: "Награды отправлены.",
  checkInGame: "Пожалуйста, примите их в игре.",
  copy: "Копировать",
  copied: "Скопировано!",
  selectTips: "Выберите лучший, на ваш взгляд, ответ.",
  multipleTips: "Можно выбрать несколько вариантов ответа.",
  leastChoose: "Выберите до xxx вариантов ответа",
  maxChoose: "Выберите хотя бы xxx вариант(ов) ответа.",
  mustAnswer: "Сначала нужно ответить на текущий вопрос.",
  mustWrite: "Пожалуйста, поделитесь своим мнением.",
  checkEmail: "Введите действительный адрес электронной почты.",
  checkPhone: "Введите действительный номер телефона.",
  isAnswer: "Вы уже прошли этот опрос.",
  unStart: "Событие недоступно",
  end: "Событие завершилось",
  server: "Выберите ваш сервер",
  role: "Выберите своего персонажа",
  common: "Система перегружена. Попробуйте позже.",
  title: "Анкета",
  titleAward: "Опрос",
  leastWord: "Введите не менее ххх символов.",
  maxWord: "Превышено ограничение символов (ххх)!",
  singleChoose: "Один ответ",
  multiChoose: "Несколько ответов",
  matrix: "Матричный вопрос",
  score: "Рейтинг",
  textLimit: "(символы xx-yyy)",
  coverGiftTitle: "Получите подарок за опрос",
  "-20001": "Не выполнен вход",
  "-20002": "Отсутствуют обязательные параметры",
  "-20003": "Анкета не найдена",
  "-20004": "Идет настройка анкеты",
  "-20005": "Анкета остановлена",
  "-20006": "Событие анкеты не началось",
  "-20007": "Событие анкеты завершено",
  "-20008": "Уже отвечено",
  "-20010": "Не удалось распределить награды",
  "-20011": "Награды за эту анкету уже распределены",
  "-20012": "Еще не отвечено",
  "-20016": "Недействительный ID игры",
};
